/* 周瑜傳・第 1 章：歷陽迎策（興平二年，195）
 * 史實：《三國志·周瑜傳》「瑜從父尚為丹楊太守，瑜往省之。會策將東渡，到歷陽，馳書報瑜，瑜將兵迎策。
 *       策大喜曰：『吾得卿，諧也。』遂從攻橫江、當利，皆拔之。」
 *       《江表傳》（裴注）孫策令：「如前在丹楊，發眾及船糧以濟大事。」
 *       《孫策傳》：劉繇「遣樊能、于麋東屯橫江津，張英屯當利口，以距術」。
 * 流程：周瑜帶丹楊兵與三輛糧車上岸，沿內陸的大路往西到歷陽；當利口、橫江津的劉繇兵會出來截糧車（盯著車打）→
 *       到歷陽見孫策（送到幾車糧，全軍就有幾成「犒軍」加成）→ 和孫策先拔橫江（樊能、于麋），再拔當利（張英）。 */
// @ts-nocheck
import { SG } from '../../core/sg.ts';
import { setLevel, ally, allyTick, boss, TROOPS, rout } from '../kit.ts';
import { ZY_PEOPLE, chase, wagon } from './zhouyu_kit.ts';
import { START, LIYANG, DANGLI, HENGJIANG, SPURS } from '../maps/zhouyu_liyang.ts';

const LV = 6, RAID_EVERY = 15, RAIDS = 6;
const FOE = { spec: TROOPS.liuyao, name: '劉繇兵', hp: 400, maxHp: 400, atk: 22 };
const CART_HP = 1100;

export default {
  id: 'zhouyu-1', map: 'zhouyu_liyang', hero: 'zhouyu',
  title: '第 1 章　歷陽迎策', year: '興平二年（195）',
  brief: {
    quote: [{ text: '會策將東渡，到歷陽，馳書報瑜，瑜將兵迎策。', src: '《三國志·吳書·周瑜傳》' }],
    text: '周瑜的從父周尚是丹楊太守，周瑜正好去探望他。孫策向袁術借兵東渡，到了歷陽，寫信給周瑜。周瑜帶著丹楊的兵、船與糧食渡江來接應。劉繇的部將屯在江邊的橫江津、當利口。',
    goals: ['護送糧車到歷陽', '和孫策會師', '拔橫江津、當利口'],
  },
  words: { ally: '丹楊兵', foe: '劉繇兵' },
  stars: [
    { text: '如史：三輛糧車都送到歷陽', ok: (m) => m.vars.delivered === 3 },
    { text: '孫策沒有倒下', ok: (m) => !m.vars.sunceDown },
    { text: '丹楊兵折損不超過 3 人', ok: (m) => m.vars.men.filter((u) => !u.alive).length <= 3 },
  ],
  steps: [
    { // 0. 護送船糧到歷陽
      enter(m, w) {
        const me = w.player, V = m.vars;
        setLevel(w, me, LV);
        me.x = START[0]; me.y = START[1];
        V.men = Array.from({ length: 6 }, (_, i) => { const u = m.recruit(me.x + 60 + (i % 3) * 50, me.y - 60 + Math.floor(i / 3) * 120, '丹楊兵'); m.join(u, me); return u; });
        V.carts = [0, 1, 2].map((i) => {
          const u = m.recruit(me.x + 140 + i * 90, me.y + 40, '糧車');
          Object.assign(u, { hp: CART_HP, maxHp: CART_HP, ms: 210, noFight: true, cart: true, atk: 0 });
          m.join(u, me);
          u.wagon = m.folk(u.x, u.y, { name: '糧車', still: true, near: 1, draw: wagon });
          return u;
        });
        V.raids = 0; V.raidT = 6; V.raiders = [];
        m.card('瑜從父尚為丹楊太守，瑜往省之。會策將東渡，到歷陽，馳書報瑜，瑜將兵迎策。', '《周瑜傳》');
        m.line('周瑜', '伯符在歷陽等著。船糧都上岸了，往西走！');
        m.after(5, () => m.line('提示', '糧車跟著你走。江邊的劉繇兵會出來截糧車——他們盯著車打，先殺截車的人。'));
        m.mark('ly', LIYANG[0], LIYANG[1], '歷陽');
        m.obj('carts', '護送糧車到歷陽', 3);
        m.prog('carts', 3);
      },
      tick(m, w, dt) {
        const me = w.player, V = m.vars, left = V.carts.filter((u) => u.alive);
        m.get('carts').text = `護送糧車到歷陽（還有 ${left.length} 輛）`;
        if (!left.length) { m.lose('船糧盡失'); return false; }
        // 截糧：車隊走到兩處江防的路口附近，江防就派人沿小路衝出來
        const cx = left.reduce((s, u) => s + u.x, 0) / left.length;
        if (V.raids < RAIDS && cx < 6500 && cx > 2200 && (V.raidT -= dt) <= 0) {
          V.raidT = RAID_EVERY; V.raids++;
          const from = cx > 3900 ? DANGLI : HENGJIANG, sp = cx > 3900 ? SPURS[0] : SPURS[1];
          const g = Array.from({ length: 4 }, (_, i) => m.foe('huangjin', sp[0] + 200 + (i % 2) * 60, sp[1] + 500 + Math.floor(i / 2) * 60, Object.assign({}, FOE, { name: '截糧兵', ms: 255 })));
          V.raiders.push(...g);
          m.line('丹楊兵', `${from === DANGLI ? '當利口' : '橫江津'}的人衝出來了！要搶糧車！`);
        }
        for (const u of V.raiders) if (u.alive) { const c = left.slice().sort((a, b) => SG.gd(a.x, a.y, u.x, u.y) - SG.gd(b.x, b.y, u.x, u.y))[0]; if (SG.gd(c.x, c.y, u.x, u.y) < 1400) chase(u, c); }
        return m.near(me, LIYANG[0], LIYANG[1], 450);
      },
    },
    { // 1. 吾得卿，諧也
      enter(m, w) {
        const me = w.player, V = m.vars;
        V.delivered = V.carts.filter((u) => u.alive).length;
        m.prog('carts', V.delivered); m.done('carts'); m.unmark('ly');
        for (const u of V.raiders) if (u.alive) { u.alive = false; u.counted = true; } // 截糧的人見到孫策的大軍就散了
        V.sc = ally(w, 'sunce', LIYANG[0] + 60, LIYANG[1] - 80, LV + 1);
        V.scMen = Array.from({ length: 6 }, (_, i) => { const u = m.recruit(LIYANG[0] - 100 - (i % 3) * 50, LIYANG[1] + 60 + Math.floor(i / 3) * 60, '江東兵'); m.join(u, V.sc); return u; });
        for (const c of V.carts) if (c.alive) { c.alive = false; c.counted = true; c.wagonGone = true; } // 糧車進了營：車停在營裡（只剩畫面）
        // 犒軍：送到幾車，全軍攻擊就加幾成
        const k = 0.06 * V.delivered;
        if (k > 0) for (const u of w.units) if (u.alive && u.team === 0) w.addBuff(u, { id: '犒軍', t: 9999, atkP: k });
        m.line('孫策', '公瑾！');
        m.after(1.5, () => m.card('策大喜曰：「吾得卿，諧也。」', '《周瑜傳》'));
        m.after(5, () => m.line('周瑜', V.delivered ? `丹楊的船糧帶來了 ${V.delivered} 車，弟兄們吃飽了好打仗。` : '船糧……都被劫走了。只能空著肚子打了。'));
        m.after(9, () => m.line('孫策', '先拔橫江津，再取當利口！'));
        V.metT = w.t;
      },
      tick(m, w) { return w.t - m.vars.metT > 10; },
    },
    { // 2. 拔橫江
      enter(m, w) {
        const V = m.vars;
        V.heng = Array.from({ length: 8 }, (_, i) => { const a = (i / 8) * Math.PI * 2; return m.foe('huangjin', HENGJIANG[0] + Math.cos(a) * 280, HENGJIANG[1] - 40 + Math.sin(a) * 180, FOE); });
        V.fn = boss(w, ZY_PEOPLE.fanneng, HENGJIANG[0] - 80, HENGJIANG[1] - 60, { name: '樊能', hp: 1900, atk: 34, armor: 5, xp: 400 });
        V.ym = boss(w, ZY_PEOPLE.yumi, HENGJIANG[0] + 90, HENGJIANG[1] - 40, { name: '于麋', hp: 1600, atk: 30, armor: 4, xp: 350 });
        m.mark('hj', HENGJIANG[0], HENGJIANG[1], '橫江津');
        m.obj('hj', '拔橫江津：擊破樊能、于麋');
        m.line('提示', '橫江津在西南的江邊。順著小路下去。');
      },
      tick(m, w) {
        const V = m.vars;
        if (V.fn.alive || V.ym.alive) return false;
        m.done('hj'); m.unmark('hj');
        rout(m, w, V.heng, [HENGJIANG[0] - 900, HENGJIANG[1] + 200]);
        m.big('拔橫江津！');
        return true;
      },
    },
    { // 3. 拔當利
      enter(m, w) {
        const V = m.vars;
        V.dl = Array.from({ length: 9 }, (_, i) => { const a = (i / 9) * Math.PI * 2; return m.foe('huangjin', DANGLI[0] + Math.cos(a) * 300, DANGLI[1] - 40 + Math.sin(a) * 190, FOE); });
        V.zy = boss(w, ZY_PEOPLE.zhangying, DANGLI[0], DANGLI[1] - 60, { name: '張英', hp: 2500, atk: 40, armor: 6, xp: 500 });
        m.after(2, () => m.line('孫策', '當利口還有張英。走！'));
        m.mark('dl', DANGLI[0], DANGLI[1], '當利口');
        m.obj('dl', '拔當利口：擊破張英');
      },
      tick(m, w) {
        const V = m.vars;
        if (V.zy.alive) return false;
        m.done('dl'); m.unmark('dl');
        rout(m, w, V.dl, [DANGLI[0] + 1500, DANGLI[1] + 100]);
        return true;
      },
    },
    { // 4. 皆拔之
      enter(m, w) {
        m.card('遂從攻橫江、當利，皆拔之。', '《周瑜傳》');
        m.after(5, () => m.card('乃渡江擊秣陵，破笮融、薛禮。轉下湖孰、江乘，進入曲阿。劉繇奔走，而策之眾已數萬矣。', '《周瑜傳》'));
        m.after(11, () => m.card('因謂瑜曰：「吾以此眾取吳會平山越已足。卿還鎮丹楊。」瑜還。', '《周瑜傳》'));
        m.after(15, () => m.win());
      },
      tick() { return false; },
    },
  ],
  always(m, w) {
    const me = w.player, V = m.vars;
    if (!me.alive) { m.lose('周瑜陣亡'); return; }
    if (V.carts) for (const c of V.carts) if (c.wagon) { if (c.alive) { c.wagon.x = c.x - 30 * (c.f || 1); c.wagon.y = c.y + 6; } else if (!c.wagonGone) { c.wagonGone = true; m.folks = m.folks.filter((f) => f !== c.wagon); w.fx({ k: 'puff', x: c.x, y: c.y }); m.line('丹楊兵', '一輛糧車被劫了！'); } }
    if (V.sc) { allyTick(w, V.sc, me); if (!V.sc.alive) V.sunceDown = true; }
  },
};
